import React from 'react';
import Icon from '../Icon/Icon';
import styles from './ExpandableDetails.module.css';

export interface ExpandableDetailsSection {
  label: string;
  content: string;
}

interface ExpandableDetailsProps {
  summary: string;
  sections: Array<ExpandableDetailsSection | null | false | undefined>;
}

const ExpandableDetails: React.FC<ExpandableDetailsProps> = ({ summary, sections }) => {
  const visibleSections = sections.filter((section): section is ExpandableDetailsSection => {
    return Boolean(section && section.content);
  });

  return (
    <details className={styles.details}>
      <summary className={styles['details-summary']}>
        <span className={styles['details-summary-text']}>{summary.trim() || '—'}</span>
        <Icon name="unfold_more" size={18} className={styles['details-summary-icon']} />
      </summary>
      <div className={styles['details-body']}>
        {visibleSections.map((section) => (
          <div key={section.label} className={styles['details-section']}>
            <span className={styles['details-label']}>{section.label}</span>
            <pre className={styles['details-content']}>{section.content}</pre>
          </div>
        ))}
      </div>
    </details>
  );
};

export default ExpandableDetails;
